<template>
  <v-container fill-height>
    <v-row>Current task: {{device.mode}}</v-row>
    <!-- <v-row>Interval: {{device.timelapse_interval}}s</v-row>
    <v-row>Location: Auto/Manual</v-row>
    <v-row>Upload type:</v-row>
    <v-row>Account:</v-row> -->
    <v-row class="mt-2">
      <v-combobox v-model="mode" :items="modeItems" label="Select task:"></v-combobox>
    </v-row>
    <v-row v-show="mode == modeItems[1]">
      <v-text-field v-model="interval" label="Interval (in seconds):"></v-text-field>
    </v-row>
    <v-row v-show="mode == modeItems[2]">
      <v-text-field label="OnSite session URL (optional)" v-model="onsiteSessionUrl"></v-text-field>
    </v-row>
    <!--
    <v-row>
      <v-combobox v-model="upload" :items="uploadItems" label="Upload type"></v-combobox>
    </v-row>
    <v-row>
      <v-text-field label="Account" placeholder="name"></v-text-field>
    </v-row>
    <v-row>
      <v-text-field label="Username" placeholder="name"></v-text-field>
    </v-row>
    <v-row>
      <v-text-field label="Password" placeholder="password" :type="'password'"></v-text-field>
    </v-row>
    <v-row>Alerts</v-row>
    <v-row class="mt-2">
      <v-divider></v-divider>
    </v-row>
    <v-row class="mt-2">
      <v-col>
        <v-text-field label="Send alert to" placeholder="email"></v-text-field>
      </v-col>
      <v-col>
        <v-text-field placeholder="SMS"></v-text-field>
      </v-col>
    </v-row>
    <v-row>Send alerts when</v-row>
    <v-row>
      <v-col>
        <v-checkbox label="Camera moves"></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox label="Camera temperature high"></v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox label="Battery charge low"></v-checkbox>
      </v-col>
    </v-row>
    -->

    <v-row align-content="space-around">
      <v-col>
        <v-btn @click="saveChanges">Apply</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';

const UPDATE_DEVICE_PROPERTIES = gql`
mutation device_update_properties($id: String!, $mode: String, $interval: Int, $onsiteSessionUrl: String) {
  update_devices_by_pk(
    pk_columns: { id: $id },
    _set: {
      mode: $mode,
      timelapse_interval: $interval,
      onsite_session_url: $onsiteSessionUrl
    }
  ) {
    mode
    timelapse_interval
    onsite_session_url
  }
}
`;

export default {
  name: 'DeviceTabTask',
  data() {
    return {
      mode: this.device.mode,
      modeItems: ['Idle', 'Timelapse', 'OnSite'],
      interval: this.device.timelapse_interval,
      upload: '',
      uploadItems: ['Google Drive', 'OneDrive', 'AWS S3'],
      onsiteSessionUrl: this.device.onsite_session_url,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  methods: {
    saveChanges() {
      const {
        interval, mode, onsiteSessionUrl,
      } = this;
      const { id } = this.device;

      const variables = {
        id,
        mode,
        interval,
      };

      if (mode === 'OnSite') {
        variables.onsiteSessionUrl = onsiteSessionUrl;
      }

      this.$apollo.mutate({
        mutation: UPDATE_DEVICE_PROPERTIES,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_devices } }) => {
          // Read the data from our cache for this query.
          // eslint-disable-next-line
          // TODO error handling what if mutation doesn't work
        },
      });
    },
  },
};
</script>
